<template>
    <div id="app">
        <b-navbar v-if="user && isAllowRoute" class="no-print" type="is-primary">
            <template slot="brand">
                <b-navbar-item tag="router-link" :to="{ path: '/dashboard' }">
                    Dalounny Closet
                </b-navbar-item>
            </template>
            <template slot="start">
                <b-navbar-item tag="router-link" to="/sell">
                    ຂາຍ
                </b-navbar-item>
                <b-navbar-dropdown label="ຈັດການສິນຄ້າ">
                    <b-navbar-item tag="router-link" to="/products">
                        ສິນຄ້າ
                    </b-navbar-item>
                    <b-navbar-item tag="router-link" to="/category">
                        ໝວດສິນຄ້າ
                    </b-navbar-item>
                    <b-navbar-item tag="router-link" to="/print-qr-barcode">
                        ພິມ QR/Barcode
                    </b-navbar-item>
                </b-navbar-dropdown>
                <b-navbar-item tag="router-link" to="/invoices">
                    ໃບບິນຮັບເງິນ
                </b-navbar-item>
                <b-navbar-dropdown label="ລາຍງານ">
                    <b-navbar-item href="#">
                        ສະຫຼຸບການຂາຍປະຈໍາວັນ
                    </b-navbar-item>
                    <b-navbar-item href="#">
                        ລາຍງານສິນຄ້າ
                    </b-navbar-item>
                    <b-navbar-item href="#">
                        ລາຍງານການຂາຍ
                    </b-navbar-item>
                </b-navbar-dropdown>
            </template>

            <template slot="end">
                <b-navbar-item @click="logout">
                    ອອກຈາກລະບົບ
                </b-navbar-item>
            </template>
        </b-navbar>
        <div :class="this.$route.name !== 'sell' ? 'container' : ''">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import {get} from "vuex-pathify";
    import {auth} from './firebase';

    export default {
        name: "App",
        components: {},
        computed: {
            user: get("userData"),
            isAllowRoute() {
                return this.$route.name !== 'sell'
                    && this.$route.name !== 'PageNotFound'
                    && this.$route.name !== 'HomePage'
            }
        },
        methods: {
            logout() {
                auth.signOut().then(res => {
                    console.log(res);
                    this.$store.set("userData", null);
                    this.$router.replace('/login');
                }).catch(err => {
                    console.log(err);
                })
            }
        }
    };
</script>

<style>
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .container {
        padding: 30px 20px;
        text-align: left;
    }
</style>
